import React, { useEffect, useRef, useState } from "react";
import '../assets/styles/Project.scss';

// Carrossel: Velvet Vein Beige Touch
import velvetVein01 from '../assets/images/projects/velvet-vein/01.jpg';
import velvetVein02 from '../assets/images/projects/velvet-vein/02.jpg';
import velvetVein03 from '../assets/images/projects/velvet-vein/03.jpg';
import velvetVein04 from '../assets/images/projects/velvet-vein/04.jpg';
import velvetVein05 from '../assets/images/projects/velvet-vein/05.jpg';
import velvetVein06 from '../assets/images/projects/velvet-vein/06.jpg';
import velvetVein07 from '../assets/images/projects/velvet-vein/07.jpg';

// Carrossel: Heartwood Bege
import heartwood01 from '../assets/images/projects/heartwood/01.jpg';
import heartwood02 from '../assets/images/projects/heartwood/02.jpg';
import heartwood03 from '../assets/images/projects/heartwood/03.jpg';
import heartwood04 from '../assets/images/projects/heartwood/04.jpg';
import heartwood05 from '../assets/images/projects/heartwood/05.jpg';
import heartwood06 from '../assets/images/projects/heartwood/06.jpg';
import heartwood07 from '../assets/images/projects/heartwood/07.jpg';

// Carrossel: Casa de Banho
import casaBanho01 from '../assets/images/projects/casa-banho/01.jpg';
import casaBanho02 from '../assets/images/projects/casa-banho/02.jpg';
import casaBanho03 from '../assets/images/projects/casa-banho/03.jpg';
import casaBanho04 from '../assets/images/projects/casa-banho/04.jpg';
import casaBanho05 from '../assets/images/projects/casa-banho/05.jpg';
import casaBanho06 from '../assets/images/projects/casa-banho/06.jpg';
import casaBanho07 from '../assets/images/projects/casa-banho/07.jpg';
import casaBanho08 from '../assets/images/projects/casa-banho/08.jpg';
import casaBanho09 from '../assets/images/projects/casa-banho/09.jpg';
import casaBanho10 from '../assets/images/projects/casa-banho/10.jpg';
import casaBanho11 from '../assets/images/projects/casa-banho/11.jpg';

// Carrossel: Bons Dias
import bonsDias01 from '../assets/images/projects/bons-dias/01.jpg';
import bonsDias02 from '../assets/images/projects/bons-dias/02.jpg';
import bonsDias03 from '../assets/images/projects/bons-dias/03.jpg';
import bonsDias04 from '../assets/images/projects/bons-dias/04.jpg';
import bonsDias05 from '../assets/images/projects/bons-dias/05.jpg';

// Design & Publicidade
import outdoorImg from '../assets/images/projects/design/outdoor.jpg';
import autocarro1 from '../assets/images/projects/design/autocarro-1.jpg';
import autocarro2 from '../assets/images/projects/design/autocarro-2.jpg';
import catalogoMockup from '../assets/images/projects/design/catalogo-mockup.jpg';

// Social Media — destaque de produto
import ambienteMacovex from '../assets/images/projects/design/ambiente-macovex.jpg';

// Vídeo & Reels — ficam em public/videos, por isso são caminhos, não imports
const videos = {
  reel1: `${process.env.PUBLIC_URL}/videos/reel-1.mp4`,
  reel2: `${process.env.PUBLIC_URL}/videos/reel-2.mp4`,
  reel3: `${process.env.PUBLIC_URL}/videos/reel-3.mp4`,
  reel4: `${process.env.PUBLIC_URL}/videos/reel-4.mp4`,
  reel1Full: `${process.env.PUBLIC_URL}/videos/reel-1-full.mp4`,
  reel2Full: `${process.env.PUBLIC_URL}/videos/reel-2-full.mp4`,
  reel3Full: `${process.env.PUBLIC_URL}/videos/reel-3-full.mp4`,
  reel4Full: `${process.env.PUBLIC_URL}/videos/reel-4-full.mp4`,
};

// ---------- Tipos ----------
type Category = 'video' | 'social' | 'design';
type ItemType = 'video' | 'image' | 'carousel';

type ProjectItem = {
  id: string;
  category: Category;
  type: ItemType;
  title: string;
  description: string;
  cover?: string;
  video?: string;
  videoFull?: string;
  images?: string[];
};

// ---------- Dados dos projetos ----------
const projectItems: ProjectItem[] = [
  // Vídeo & Reels
  {
    id: 'reel-pavimentos',
    category: 'video',
    type: 'video',
    title: 'Pavimentos & Revestimentos',
    description: 'Reel de apresentação de gama de pavimentos e revestimentos.',
    video: videos.reel1,
    videoFull: videos.reel1Full,
  },
  {
    id: 'reel-catalogo',
    category: 'video',
    type: 'video',
    title: 'O Catálogo',
    description: 'Reel de apresentação do catálogo de amostras.',
    video: videos.reel2,
    videoFull: videos.reel2Full,
  },
  {
    id: 'reel-revestimento',
    category: 'video',
    type: 'video',
    title: 'Showcase de Pormenores de Revestimento',
    description: 'Reel de destaque de revestimento em pormenor.',
    video: videos.reel3,
    videoFull: videos.reel3Full,
  },
  {
    id: 'reel-macovex',
    category: 'video',
    type: 'video',
    title: 'Pormenores Macovex',
    description: 'Reel institucional com pormenores de mobiliário de casa de banho.',
    video: videos.reel4,
    videoFull: videos.reel4Full,
  },

  // Social Media & Carrosséis
  {
    id: 'carrossel-velvet-vein',
    category: 'social',
    type: 'carousel',
    title: 'Elegância Fluida — Velvet Vein Beige Touch',
    description: 'Carrossel de apresentação de gama de revestimento.',
    cover: velvetVein01,
    images: [velvetVein01, velvetVein02, velvetVein03, velvetVein04, velvetVein05, velvetVein06, velvetVein07],
  },
  {
    id: 'carrossel-heartwood',
    category: 'social',
    type: 'carousel',
    title: 'Beleza Natural — Heartwood Bege',
    description: 'Carrossel de apresentação de gama de pavimento.',
    cover: heartwood01,
    images: [heartwood01, heartwood02, heartwood03, heartwood04, heartwood05, heartwood06, heartwood07],
  },
  {
    id: 'carrossel-casa-banho',
    category: 'social',
    type: 'carousel',
    title: 'Casa de Banho — Detalhes que Fazem a Diferença',
    description: 'Carrossel de destaque de produto para casa de banho.',
    cover: casaBanho01,
    images: [
      casaBanho01, casaBanho02, casaBanho03, casaBanho04, casaBanho05,
      casaBanho06, casaBanho07, casaBanho08, casaBanho09, casaBanho10, casaBanho11,
    ],
  },
  {
    id: 'carrossel-bons-dias',
    category: 'social',
    type: 'carousel',
    title: 'Aqui Começam os Bons Dias',
    description: 'Carrossel de conteúdo lifestyle sobre rotinas matinais.',
    cover: bonsDias01,
    images: [bonsDias01, bonsDias02, bonsDias03, bonsDias04, bonsDias05],
  },
  {
    id: 'destaque-ambiente-macovex',
    category: 'social',
    type: 'image',
    title: 'Destaque de Ambiente',
    description: 'Publicação de destaque de produto/showroom para redes sociais.',
    cover: ambienteMacovex,
  },

  // Design & Publicidade
  {
    id: 'outdoor-termas',
    category: 'design',
    type: 'image',
    title: 'Outdoor — Termas de Alcafache',
    description: 'Outdoor publicitário aplicado, Viseu.',
    cover: outdoorImg,
  },
  {
    id: 'autocarro-1',
    category: 'design',
    type: 'image',
    title: 'Publicidade em Autocarro — Termas de Alcafache',
    description: 'Publicidade aplicada em autocarro urbano, Viseu.',
    cover: autocarro1,
  },
  {
    id: 'autocarro-2',
    category: 'design',
    type: 'image',
    title: 'Publicidade em Autocarro — Termas de Alcafache',
    description: 'Publicidade aplicada em autocarro urbano, Viseu.',
    cover: autocarro2,
  },
  {
    id: 'catalogo-spa',
    category: 'design',
    type: 'image',
    title: 'Catálogo & Preçário — SPA Termal',
    description: 'Design de catálogo de tratamentos e preçário, Termas de Alcafache.',
    cover: catalogoMockup,
  },
];

const filters: { key: Category | 'all'; label: string }[] = [
  { key: 'all', label: 'Todos' },
  { key: 'video', label: 'Vídeo & Reels' },
  { key: 'social', label: 'Social Media' },
  { key: 'design', label: 'Design & Publicidade' },
];

// ---------- Vídeo que só reproduz quando está visível no ecrã ----------
function LazyVideo({ src }: { src: string }) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = true;

    const log = (label: string) => () =>
      console.log(label, src, {
        readyState: video.readyState,
        networkState: video.networkState,
        videoWidth: video.videoWidth,
        videoHeight: video.videoHeight,
        paused: video.paused,
      });

    video.addEventListener('loadedmetadata', log('loadedmetadata'));
    video.addEventListener('canplay', log('canplay'));
    video.addEventListener('playing', log('playing'));
    video.addEventListener('stalled', log('stalled'));
    video.addEventListener('suspend', log('suspend'));
    video.addEventListener('error', () => console.error('error', src, video.error));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          console.log('intersecting?', src, entry.isIntersecting);
          if (entry.isIntersecting) {
            if (video.paused) {
              video.muted = true;
              video.play().catch((err) => {
                if (err.name !== 'AbortError') {
                  console.error('Falha ao dar play no vídeo', src, err);
                }
              });
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, [src]);

  return (
    <video ref={videoRef} className="project-video" muted loop playsInline preload="auto">
      <source src={src} type="video/mp4" />
    </video>
  );
}

// ---------- Componente principal ----------
function Project() {
  const [activeFilter, setActiveFilter] = useState<Category | 'all'>('all');
  const [lightboxItem, setLightboxItem] = useState<ProjectItem | null>(null);
  const [slideIndex, setSlideIndex] = useState(0);
  const lightboxVideoRef = useRef<HTMLVideoElement>(null);

  const visibleItems =
    activeFilter === 'all' ? projectItems : projectItems.filter((item) => item.category === activeFilter);

  const openLightbox = (item: ProjectItem) => {
    setLightboxItem(item);
    setSlideIndex(0);
  };

  const closeLightbox = () => setLightboxItem(null);

  const nextSlide = () => {
    if (!lightboxItem?.images) return;
    setSlideIndex((i) => (i + 1) % lightboxItem.images!.length);
  };

  const prevSlide = () => {
    if (!lightboxItem?.images) return;
    setSlideIndex((i) => (i - 1 + lightboxItem.images!.length) % lightboxItem.images!.length);
  };

  useEffect(() => {
    document.body.style.overflow = lightboxItem ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [lightboxItem]);

  useEffect(() => {
    if (lightboxVideoRef.current) {
      lightboxVideoRef.current.volume = 0.5;
    }
  }, [lightboxItem]);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (!lightboxItem) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') nextSlide();
      if (e.key === 'ArrowLeft') prevSlide();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  });

  return (
    <div className="projects-container" id="projects">
      <h1>Projetos & Conteúdos</h1>

      <div className="projects-filters">
        {filters.map((f) => (
          <button
            key={f.key}
            className={activeFilter === f.key ? 'active' : ''}
            onClick={() => setActiveFilter(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="projects-masonry">
        {visibleItems.map((item) => (
          <div key={item.id} className="masonry-item" onClick={() => openLightbox(item)}>
            {item.type === 'video' ? (
              <LazyVideo src={item.video!} />
            ) : (
              <img src={item.cover} alt={item.title} loading="lazy" />
            )}

            {item.type === 'carousel' && <span className="badge">{item.images?.length} fotos</span>}
            {item.type === 'video' && <span className="badge">Reel</span>}

            <div className="overlay">
              <span className="overlay-category">
                {filters.find((f) => f.key === item.category)?.label}
              </span>
              <h3>{item.title}</h3>
              <span className="overlay-hint">Ver mais ↗</span>
            </div>
          </div>
        ))}
      </div>

      {lightboxItem && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>✕</button>

          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            {lightboxItem.type === 'video' && (
              <video ref={lightboxVideoRef} className="lightbox-video" controls autoPlay loop playsInline>
                <source src={lightboxItem.videoFull || lightboxItem.video} type="video/mp4" />
              </video>
            )}

            {lightboxItem.type === 'image' && (
              <img src={lightboxItem.cover} alt={lightboxItem.title} />
            )}

            {lightboxItem.type === 'carousel' && lightboxItem.images && (
              <div className="lightbox-carousel">
                <button className="arrow left" onClick={prevSlide}>‹</button>
                <img src={lightboxItem.images[slideIndex]} alt={lightboxItem.title} />
                <button className="arrow right" onClick={nextSlide}>›</button>
                <span className="counter">
                  {slideIndex + 1} / {lightboxItem.images.length}
                </span>
              </div>
            )}

            <div className="lightbox-info">
              <h3>{lightboxItem.title}</h3>
              <p>{lightboxItem.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Project;